var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allcontain"},[_c('div',{staticClass:"bottom"},[_c('p',[_vm._v("沈阳星游网络技术有限公司 版权所有 ")]),_c('div',{staticStyle:{"margin-top":"20px"},on:{"click":_vm.openNewWindow}},[_vm._v("辽ICP备2023009521号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }